import { useEffect, useState } from "react";

import { Container, Offcanvas } from "react-bootstrap";
import { useSelector } from "react-redux";

import SntCloseIcon from "@icons/SntCloseIcon";

import SidebarBody from "./SidebarBody";
import SidebarLogo from "./SidebarLogo";

import CloudWhiteIcon from "@images/cloud-logo-white.svg";
import CloudBlueIcon from "@images/cloud-icon-blue-01-32x32.png";

import { RootState } from "@/types/RootState";
import { isSystemUser } from "@/utils/orgTypeUtils";

function Sidebar(): JSX.Element {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const { logoPath, menuType, showCanvasMenu } = useSelector(
    (state: RootState) => state.all
  );
  const { isMobile } = useSelector((state: RootState) => state.all);
  const loginInfo = useSelector((state: RootState) => state.user);

  // Normal/partner orgs get the 6.0.3 menu branding (full-height colored sidebar with
  // their logo at the top); system users keep the redesigned header logo.
  const showSidebarBranding = !isSystemUser(loginInfo);

  useEffect(() => {
    setShowMenu(showCanvasMenu ?? false);
  }, [showCanvasMenu]);

  // only close when click on link of sidebar
  const onOffCanvasClicked = (e: React.MouseEvent<HTMLDivElement>): void => {
    e.preventDefault();
    if (
      (e.target as HTMLElement).classList.contains("nav-link") ||
      (e.target as HTMLElement).classList.contains("sidebar-normal")
    ) {
      if (showMenu) {
        setShowMenu(false);
      }
    }
  };

  return !isMobile ? (
    <Container>
      <div
        className={`sidebar snt-sidebar${showSidebarBranding ? " sidebar-with-logo" : ""}`}
        data-color={menuType === "MAIN" ? "home" : "admin"}
      >
        {showSidebarBranding && <SidebarLogo logoPath={logoPath} />}
        <SidebarBody />
      </div>
    </Container>
  ) : (
    <Container>
      <Offcanvas
        show={showMenu}
        onHide={() => {
          setShowMenu(false);
        }}
        style={{
          width: "100%",
          backgroundColor: menuType === "MAIN" ? "#4E5471" : "#EFF3F4",
        }}
        collapseonselect={"true"}
      >
        <div>
          <div className="text-center" style={{ marginTop: 5 }}>
            {isMobile && loginInfo.custumInfo === undefined && (
              <img
                src={menuType === "MAIN" ? CloudWhiteIcon : CloudBlueIcon}
                style={{ width: 32, height: 32 }}
                alt={"Logo"}
              />
            )}
          </div>
          <SntCloseIcon
            size={20}
            style={{
              color: menuType === "MAIN" ? "white" : "grey",
              position: "absolute",
              right: 13,
              top: 13,
            }}
            onClick={() => setShowMenu(false)}
          />
        </div>
        <Offcanvas.Body className="p-0" onClick={onOffCanvasClicked}>
          <div
            className={`sidebar snt-sidebar${showSidebarBranding ? " sidebar-with-logo" : ""}`}
            data-color={menuType === "MAIN" ? "home" : "admin"}
          >
            {showSidebarBranding && <SidebarLogo logoPath={logoPath} />}
            <SidebarBody />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </Container>
  );
}

export default Sidebar;
